import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import { getProfile } from '../../api/auth';
import { getOrderList } from '../../api/orderHistory';
import { useCommonContext } from '../../components/provider/CommonProvider';
import { imgURL } from '../Home';

export default function Event100wonshop() {
  const [parseData, setParseData] = useState<any>();
  const [orderList, setOrderList] = useState<any>();
  const { hasAccessToken } = useCommonContext();
  const location = useLocation();
  useEffect(() => {
    if (hasAccessToken) {
      getProfile().then((res) => {
        const parseData = JSON.parse(res.data.additionalInfo);
        setParseData(parseData);
      });
    }
  }, []);

  useEffect(() => {
    if (hasAccessToken) {
      getOrderList().then((res) => {
        setOrderList(res.data.items);
      });
    }
  }, [location]);
  return (
    <div className="main_wrap">
      <div className="contents_wrap">
        {isMobile ? (
          <div className="event_100wonshop_wrap">
            <div className="event_100wonshop">
              <img src={`${imgURL}/img_100wonshop_mo_01_2.png`} alt="" />
              <img src={`${imgURL}/img_100wonshop_mo_02_3.png`} alt="" />
              {/* <img src={`${imgURL}/img_100wonshop_mo_03.png`} alt='' /> */}
              {/* 가입하고 혜택받기 */}
              <a
                href="/100wonshop"
                onClick={(e) => {
                  if (!hasAccessToken) {
                    e.preventDefault();
                    alert('회원가입 시 구매하실 수 있습니다.');
                    return;
                  } else if (parseData.shopifyUserOrder) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  } else if (orderList.length !== 0) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  }
                }}
              >
                <img src={`${imgURL}/img_100wonshop_mo_04_2.png`} alt="" />
              </a>
              <img src={`${imgURL}/img_100wonshop_mo_05_2.png`} alt="" />
              {/* <img src={`${imgURL}/img_100wonshop_mo_06.png`} alt='' />
              <img src={`${imgURL}/img_100wonshop_mo_07.png`} alt='' />
              <img src={`${imgURL}/img_100wonshop_mo_08.png`} alt='' />
              <img src={`${imgURL}/img_100wonshop_mo_09.png`} alt='' /> */}
              <a
                href="/100wonshop"
                onClick={(e) => {
                  if (!hasAccessToken) {
                    e.preventDefault();
                    alert('회원가입 시 구매하실 수 있습니다.');
                    return;
                  } else if (parseData.shopifyUserOrder) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  } else if (orderList.length !== 0) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  }
                }}
              >
                <img src={`${imgURL}/img_100wonshop_mo_10_2.png`} alt="" />
              </a>
              <img src={`${imgURL}/img_100wonshop_mo_11_2.png`} alt="" />
            </div>
          </div>
        ) : (
          <div className="event_100wonshop_wrap">
            <div className="event_100wonshop">
              <img src={`${imgURL}/img_100wonshop_pc_01_2.png`} alt="" />
              {/* <img src={`${imgURL}/img_100wonshop_pc_02_1.png`} alt='' /> */}
              <img src={`${imgURL}/img_100wonshop_pc_03_3.png`} alt="" />
              {/* 가입하고 혜택받기 */}
              <a
                href="/100wonshop"
                onClick={(e) => {
                  if (!hasAccessToken) {
                    e.preventDefault();
                    alert('회원가입 시 구매하실 수 있습니다.');
                    return;
                  } else if (parseData.shopifyUserOrder) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  } else if (orderList.length !== 0) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  }
                }}
              >
                <img src={`${imgURL}/img_100wonshop_pc_04_2.png`} alt="" />
              </a>
              <img src={`${imgURL}/img_100wonshop_pc_05_2.png`} alt="" />
              <img src={`${imgURL}/img_100wonshop_pc_06_2.png`} alt="" />
              {/* <img src={`${imgURL}/img_100wonshop_pc_07.png`} alt='' />
              <img src={`${imgURL}/img_100wonshop_pc_08.png`} alt='' />
              <img src={`${imgURL}/img_100wonshop_pc_09.png`} alt='' /> */}
              <a
                href="/100wonshop"
                onClick={(e) => {
                  if (!hasAccessToken) {
                    e.preventDefault();
                    alert('회원가입 시 구매하실 수 있습니다.');
                    return;
                  } else if (parseData.shopifyUserOrder) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  } else if (orderList.length !== 0) {
                    e.preventDefault();
                    alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.');
                    return;
                  }
                }}
              >
                <img src={`${imgURL}/img_100wonshop_pc_10_2.png`} alt="" />
              </a>
              <img src={`${imgURL}/img_100wonshop_pc_11_2.png`} alt="" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
